<template>
  <div class="start-content-container justify-content-center">
    <div class="start-content" :style="{ width: `${width}%` }">
      <div class="header w-100 m-0 bg-fwd-orange fwd-white text-break">
        <slot name="header"></slot>
      </div>
      <div class="description">
        <slot name="description"></slot>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  setup() {},
  props: {
    width: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style scoped></style>
